import { NavigateFunction } from "react-router-dom";
import { isAppRunningInDev } from "./utils";
import { PUBLIC_ROUTER } from "constants/routes";
import { LOCAL_STORAGE_IS_FROM_PRESIGNUP_FLOW, LOCAL_STORE_DONE_SIGN_UP } from "constants/localStore";
import { getLocalStorageOneItem, removeLocalStorageOneItem, setLocalStorageOneItem } from "./localStorage";
import { trackSuccessOTP } from "analytics/TrackCustomEventsHandlers/triggerCustomAppEvent";
import { ScreenNamesTypes } from "interfaces/CustomAppEvents/customAppParamsValues.interface";

const navigateToSignUpFormPages = ({
  navigate,
  path,
  mobileNumber,
  replace = false,
  record,
  filepath,
  surveyDataID,
  storeFormatName = "",
}: {
  navigate: NavigateFunction;
  path: string;
  mobileNumber: string;
  record: {
    [key: string]: any;
  };
  replace?: boolean;
  filepath?: any;
  surveyDataID?: string;
  storeFormatName?: string;
}) => {
  if (isAppRunningInDev()) {
    console.log("--- RUN navigateToSignUpFormPages: ", {
      replace,
      state: {
        mobileNumber,
        record,
      },
    });
  }

  navigate(path, {
    replace,
    state: {
      mobileNumber,
      record,
      ...(!!filepath ? { filepath } : {}),
      surveyDataID,
      storeFormatName,
    },
  });
};

const getSignUpPointXPointYRecord = (record: any) => {
  const pointX = Number(record?.point_x || 0);
  const pointY = Number(record?.point_y || 0);

  return {
    pointX,
    pointY,
  };
};

const setSignUpPointXPointY = (latitude: number, longitude: number) => {
  const pointY = latitude || 0;
  const pointX = longitude || 0;

  return {
    pointY,
    pointX,
  };
};

const navigateToSignUpFlowFromPresignUpPage = (navigate: NavigateFunction) => {
  setPreSignUpFlow(true);
  navigate(PUBLIC_ROUTER.SIGNUP.path);
};

const isPreSignUpFlow = (pathname: string) => {
  return !!pathname.match(PUBLIC_ROUTER.PUBLIC_PRODUCTS_LIST.path);
};

const setPreSignUpFlow = (isFromPreSignUpPage: boolean) => {
  localStorage.setItem(LOCAL_STORAGE_IS_FROM_PRESIGNUP_FLOW, `${isFromPreSignUpPage}`);
};

const getIsPreSignUpFlowFlag = () => {
  return localStorage.getItem(LOCAL_STORAGE_IS_FROM_PRESIGNUP_FLOW) === "true";
};

const setDoneSignUpLocalFlag: (status?: boolean) => void = (status = true) => {
  removeLocalStorageOneItem(LOCAL_STORE_DONE_SIGN_UP);

  if (status) {
    setLocalStorageOneItem(LOCAL_STORE_DONE_SIGN_UP, "true");
  } else {
    removeLocalStorageOneItem(LOCAL_STORE_DONE_SIGN_UP);
  }
};

const handleTrackDoneSignUpFlow = () => {
  const isDoneSignUp = getLocalStorageOneItem(LOCAL_STORE_DONE_SIGN_UP) === "true";

  if (isDoneSignUp) {
    trackSuccessOTP({
      current_screen_name: ScreenNamesTypes.sign_up_otp,
    });
  }

  removeLocalStorageOneItem(LOCAL_STORE_DONE_SIGN_UP);
};

export {
  navigateToSignUpFormPages,
  getSignUpPointXPointYRecord,
  setSignUpPointXPointY,
  navigateToSignUpFlowFromPresignUpPage,
  isPreSignUpFlow,
  setPreSignUpFlow,
  getIsPreSignUpFlowFlag,
  setDoneSignUpLocalFlag,
  handleTrackDoneSignUpFlow,
};
